import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Typography } from 'antd';
import {useNavigate} from 'react-router-dom';

import { Paper } from 'componets/ui';
import { CodeField, FormItem } from 'componets/form';
import { Login2FALayout } from 'componets/layouts';

import { CODE_LENGTH, Rules, ClientStatus, Paths } from 'utils/constants';

import { useAppSelector, useCodeForm, useTranslate } from 'hooks';

import { AppDispatch } from 'store';

import { ReactComponent as ArrowBack } from 'assets/icons/arrow-back.svg';

import s from '../index.module.scss';
import {loginOTP} from "../../../features/authorization/actions/loginOTP";
import Timer from "../../../componets/ui/Timer";
import {useTranslation} from "react-i18next";

export const LoginOTP: FC = () => {
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const { t } = useTranslation()
	const otp = useAppSelector((state) => state.authorization.otp);
	const { fields, disabled, setFields, setIsValid, isValid, setDisabled, code } = useCodeForm();

	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		if (isValid) {
			setDisabled(true);

			dispatch(loginOTP({ code: code.value, identifier: otp?.identifier }))
				.unwrap()
				.then((r) => {
					navigate(r.status === ClientStatus.ACTIVE ? Paths.OVERVIEW : Paths.REGISTER);
				})
				.catch((e) => {
					setFields([{ ...code, errors: [t(e.message)] }]);
					setDisabled(false);
					setIsValid(false);
					form.resetFields();
				});
		}
	}, [code, dispatch, isValid, navigate, otp, setDisabled, setFields, setIsValid]);

	const { backText, googleAuthenticatorText, verifyEmailLabelText } = useTranslate([
		'backText',
		'googleAuthenticatorText',
		'verifyEmailLabelText',
	]);
	useEffect(() => {
		if (!otp?.identifier && !otp?.errors) {
			navigate('/')
		}
	}, [otp, navigate]);
	return (
		<Login2FALayout>
			<Paper>
				<Typography.Title level={4}>{googleAuthenticatorText}</Typography.Title>
				{otp?.errors && (
					<Typography.Text>
						<span className={s.limitMessage}>{t(otp?.errors?.limit.message)}</span>
						<span className={s.tryAgain}>
							{t("try_again_in")}{" "}
							<Timer
								formatted={true}
								until={otp?.errors?.limit.lockedUntil}
								onSuccess={() => {
									navigate('/');
								}}
							/>
						</span>
					</Typography.Text>
				)}
				{otp?.identifier?.length > 0 && (
					<>
						<Typography.Text>{verifyEmailLabelText} {otp?.credentials}</Typography.Text>
						<Form form={form} onFieldsChange={setFields} fields={fields}>
							<FormItem className="code" name="code" rules={[Rules.REQUIRED]}>
								<CodeField
									name="code"
									fields={CODE_LENGTH}
									disabled={disabled}
									autoComplete="one-time-code"
								/>
							</FormItem>
						</Form>
					</>
				)}
				<div className={s.loginBack}>
					<button className="modal-backButton" type="button" onClick={() => navigate('/')}>
						<ArrowBack />
						{backText}
					</button>
				</div>
			</Paper>
		</Login2FALayout>
	);
};
